<template>
  <div class="app-container news-detail">
    <basic-container>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本资料" name="first">

        <div v-if="!dialogEditVisible">
          <div class="news-detail-title">
            <el-button size="medium" type="primary" class="news-detail-title-button"
                    icon="el-icon-edit" v-if="newsManager_btn_edit"
                    @click="handleUpdate(newsDetail)">编辑</el-button>
          </div>
          <div class="news-detail-first">
            <el-row class="news-detail-item">
              <el-col :span="2" class="head">ID:</el-col>
              <el-col :span="16">{{ newsDetail.id }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">标题:</el-col>
              <el-col :span="22">{{ newsDetail.title }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">摘要:</el-col>
              <el-col :span="22">
                <el-scrollbar><div v-html="newsDetail.summary" /></el-scrollbar>
              </el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">标签:</el-col>
              <el-col :span="16">{{ newsDetail.tagName || '--' }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">收藏:</el-col>
              <el-col :span="16">{{ newsDetail.favoriteCount }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">状态:</el-col>
              <el-col :span="16">{{ newsDetail.status }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">发布时间:</el-col>
              <el-col :span="16">{{ newsDetail.publishDate }}</el-col>
            </el-row>

            <div class="news-detail-source-title">
              <span>来源</span>
              <el-button size="medium" type="primary" class="news-detail-source-title-button"
                icon="el-icon-plus" v-if="newsManager_btn_source_create_delete"
                @click="handleAddSourceClick()">添加</el-button>
            </div>
            <el-table class="news-detail-source"
              :data="newsDetail.sources"
              stripe
              border
              style="width: 100%">
              <el-table-column
                prop="articleId"
                label="ID"
                width="60">
              </el-table-column>
              <el-table-column
                prop="articleTitle"
                label="标题"
                width="200">
              </el-table-column>
              <el-table-column
                prop="sourceName"
                label="来源"
                width="180">
                <template slot-scope="scope"><div v-html="scope.row.sourceName"></div></template>
              </el-table-column>
              <el-table-column
                prop="articleUrl"
                label="URL"
                width="400">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="handleDeleteSourceClick(scope.row,scope.index)" type="text" size="medium"
                  v-if="newsManager_btn_source_create_delete">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-if="dialogEditVisible">
          <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
            <el-form-item>
                <el-button type="primary" class="news-detail-dialog-publish-save"
                @click="handleEditSave('editForm')">保存</el-button>
                <el-button class="news-detail-dialog-publish-cancel"
                @click="cancelEdit('editForm')">取消</el-button>
            </el-form-item>
            <el-form-item label="标题" prop="title" class="news-detail-dialog-title">
                <el-input v-model="editForm.title"></el-input>
            </el-form-item>
            <el-form-item label="摘要" class="news-detail-dialog-summary">
                <el-input type="textarea" :rows="6" :maxlength="500" v-model="editForm.summary">
                </el-input>
            </el-form-item>
            <el-form-item label="标签" class="news-detail-dialog-item">
              <el-select v-model="editForm.tagIds" placeholder="请选择" multiple filterable remote :remote-method="remoteSearchTag">
                <el-option
                    v-for="item in editTagOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
             </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="isBanned" class="news-detail-dialog-item">
              <el-select v-model="editForm.isBanned" placeholder="请选择">
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        </el-tab-pane>
        <el-tab-pane label="相关资讯" name="second">
          <el-button size="medium" type="primary" class="news-detail-relatedNews-button"
              icon="el-icon-plus" @click="handleAddRelatedNewsClick()">添加</el-button>
          <el-table class="news-detail-relatedNews" :data="relatedNewsData" style="width: 100%">
              <el-table-column align="center" prop="newsId" label="ID" width="150"></el-table-column>
              <el-table-column align="center" prop="title" label="标题" width="180"></el-table-column>
              <el-table-column align="center" prop="tagName" label="标签" width="150"></el-table-column>
              <el-table-column align="center" prop="sourceName" label="来源" width="150">
                <template slot-scope="scope"><div v-html="scope.row.sourceName"></div></template>
              </el-table-column>
              <el-table-column align="center" prop="status" label="状态" width="150"></el-table-column>
              <el-table-column align="center" prop="publishDate" label="发布时间" width="100"></el-table-column>
              <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button @click="handleDeleteRelatedNewsClick(scope.row,scope.index)" type="text"
                    size="medium">删除</el-button>
                </template>
              </el-table-column>
          </el-table>
          <el-pagination :page-size="relatedNewsPage.pageSize"
                         :page-sizes="relatedNewsPage.pageSizes"
                         :current-page="relatedNewsPage.currentPage"
                         :total="relatedNewsPage.total"
                         :layout="relatedNewsPage.layout"
                         @current-change="relatedNewsCurrentChange"
                         @size-change="relatedNewsSizeChange">
          </el-pagination>
        </el-tab-pane>

      </el-tabs>

      <el-dialog title="添加来源" class="news-detail-dialog"
               :visible.sync="dialogAddSourceVisible" :close-on-click-modal="false">
        <el-form ref="addSourceForm" :model="addSourceForm" :rules="addSourceRules" label-width="80px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="addSourceForm.title"></el-input>
          </el-form-item>
          <el-form-item label="来源" prop="name">
            <el-input v-model="addSourceForm.name"></el-input>
          </el-form-item>
          <el-form-item label="URL" prop="url">
            <el-input v-model="addSourceForm.url"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="news-detail-dialog-publish-save"
              @click="handleAddSource('addSourceForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog title="添加相关资讯" class="news-detail-add-dialog"
                :visible.sync="dialogAddRelatedNewsVisible" :close-on-click-modal="false">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <label class="news-detail-add-dialog-filter-label">标题</label>
            <el-input class="news-detail-add-dialog-filter-value" v-model="addNewsFilter.title" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="news-detail-add-dialog-filter-label">标签</label>
            <el-autocomplete class="news-detail-add-dialog-filter-value"
              v-model="addNewsFilter.selectedTag"
              :fetch-suggestions="getTagsByTagProp"
              :trigger-on-focus="false"
              @select="handleSelect">
            </el-autocomplete>
          </div>
        </el-col>
        <div>
          <el-button class="news-detail-add-dialog-filter-search" size="small" @click="searchResetAdd">清空</el-button>
          <el-button class="news-detail-add-dialog-filter-reset" type="primary" size="small" @click="searchChangeAdd">搜索</el-button>
        </div>
        <el-table :data="addRelatedNewsData" style="width: 100%" @selection-change="changeSelectedRelatedNews">
            <el-table-column align="center" prop="newsId" label="ID" width="60"></el-table-column>
            <el-table-column align="center" prop="title" label="标题" width="200"></el-table-column>
            <el-table-column align="center" prop="tagName" label="标签" width="150"></el-table-column>
            <el-table-column align="center" prop="publishDate" label="发布时间" width="100"></el-table-column>
            <el-table-column align="center" type="selection" label="操作" width="120"></el-table-column>
        </el-table>
        <el-pagination :page-size="addRelatedNewsPage.pageSize"
                       :page-sizes="addRelatedNewsPage.pageSizes"
                       :current-page="addRelatedNewsPage.currentPage"
                       :total="addRelatedNewsPage.total"
                       :layout="addRelatedNewsPage.layout"
                       @current-change="addRelatedNewsCurrentChange"
                       @size-change="addRelatedNewsSizeChange">
        </el-pagination>
        <div>
          <el-button size="medium" type="primary" class="news-detail-relatedNews-save"
            @click="saveSelectedRelatedNews">保存</el-button>
        </div>
      </el-dialog>

    </basic-container>
  </div>
</template>

<script>
  import { getNewsDetailById, putBasicNews, putNews, addNews, delNewsSources, addNewsSource, getRelatedNews, delRelatedNews, addRelatedNews, getAddRelatedNewsPage } from '@/api/news/news'
  import { getTagList, getTagListByTag } from '@/api/dict/tag'
  import { getSourceList } from '@/api/news/source'
  import { mapGetters } from 'vuex'

  const initDetail = vm => {
    // TODO hasDeletedSource
    getNewsDetailById(vm.id).then(response => {
      let data = response.data
      if (response.status == 200) {
        // 资讯详情
        formatNewsDetail(vm, vm.newsDetail, data.data) // 获取基本资料
        if (vm.$route.query.edit == 'true') {
          vm.handleUpdate(vm.newsDetail)
        }
      } else {
        vm.$message({
          showClose: true,
          message: '无法查看该资讯详情',
          type: 'error'
        })
      }
    }).catch(error => {
      vm.$message({
        message: '获取资讯详情失败',
        type: 'error'
      })
    })
    // 获取相关资讯
    vm.getRelatedNews()
  }

  const formatNewsDetail = (vm, detail, data) => {
    // 资讯详情格式化
    if (data) {
      // 获取资讯基本资料
      detail.id = data.id
      if (!data.title || data.title.length == 0) { detail.title = "--" }
      else { detail.title = data.title }
      if (!data.summary || data.summary.length == 0) { detail.summary = "--" }
      else { detail.summary = data.summary }
      if (!data.favoriteCount) { detail.favoriteCount = "0" }
      else { detail.favoriteCount = data.favoriteCount }
      if (data.isBanned) { detail.status = "已下架" }
      else { detail.status = "已上架" }
      if (!data.publishDate) { detail.publishDate = "=" }
      else { detail.publishDate = data.publishDate }

      detail.sources = data.sources
      if (detail.sources && detail.sources.length > 0) {
        detail.sourceNameForDisplay = ''
        detail.sources.forEach(function(source, index) {
          if (!source.isDisplay) {
            source.sourceName = "<span style='color:#BBBBBB'>" + source.sourceName + "<span>"
          }
        })
      }
      detail.sourceId = data.sourceId
      detail.category = data.category

      // 调取资讯的相应标签,并且格式化
      detail.newsTags = data.newsTags
      detail.newsTagId = data.newsTagId
      if (!data.newsTags || data.newsTags.length == 0) {
        detail.tagName = "--"
      } else {
        detail.tagName = ""
        data.newsTags.forEach(function(newsTag, index) {
          if (index == 0) {
            detail.tagName += newsTag.newsTagName
          } else {
            detail.tagName += '，' + newsTag.newsTagName
          }
        })
        vm.editTagOptions = data.newsTags.map(tag => {
          return {
            label: tag.newsTagName,
            value: tag.newsTagId
          }
        })
      }
    }
  }

  export default {
    data () {
      return {
        // 查看详情窗口
        activeName: "first",
        newsDetail:{
          id: null,
          title: "",
          summary: "",
          tagName: "",
          favoriteCount: 0,
          status: "",
          publishDate: "",
          sources: []
        },
        hasDeletedSource: false,

        // 添加来源窗口
        dialogAddSourceVisible: false,
        addSourceing: false,
        addSourceForm: {
          title: "",
          name: "",
          url: ""
        },
        addSourceRules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur'}
          ],
          name: [
            { required: true, message: '请输入来源', trigger: 'blur'}
          ],
          url: [
            { required: true, message: '请输入URL', trigger: 'blur'}
          ]
        },

        // 编辑窗口
        dialogEditVisible: false,
        editTagOptions: [],
        editForm: {
          id: null,
          title: "",
          summary: "",
          tagIds: [],
          isBanned: null
        },
        editRules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur'}
          ],
          isBanned: [
            { required: true, message: '请选择状态', trigger: 'blur'}
          ]
        },
        statusOptions: [
          {
            label: "上架",
            value: 0
          },
          {
            label: "下架",
            value: 1
          }
        ],

        // 相关资讯列表
        relatedNewsFilter: {
          current: 1,
          size: 20,
        },
        relatedNewsData: [],
        relatedNewsPage: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20, // 每页显示多少条
          pageSizes: [10, 20, 30, 40, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper"
        },

        // 相关资讯-添加相关资讯窗口
        dialogAddRelatedNewsVisible: false,
        addNewsFilter: {
          current: 1,
          size: 20,
          title: "",
          selectedTag: null,
          selectedTagId: undefined,
          tags: [],
        },
        addRelatedNewsData:[], // 添加相关资讯dialog显示所有news
        addRelatedNewsPage: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20, // 每页显示多少条
          pageSizes: [10, 20, 30, 40, 50, 100],
          layout: "total, sizes, prev, pager, next"
        },
        selectedRelatedNews: [], // 用户选中的相关资讯
        relatedNewsCheckBox: false,

        // 权限控制组件
        newsManager_btn_publish: false,
        newsManager_btn_edit: false,
        newsManager_btn_up: false,
        newsManager_btn_down: false,
        newsManager_btn_source_create_delete: false
      }
    },
    watch: {
      $route () {
        this.id = this.$route.params.id
        initDetail(this)
      }
    },
    mounted () {
      this.id = this.$route.params.id
      initDetail(this)
    },
    created() {
      this.newsManager_btn_publish = this.permissions['sys_news_publish']
      this.newsManager_btn_edit = this.permissions['sys_news_edit']
      this.newsManager_btn_up = this.permissions['sys_news_up']
      this.newsManager_btn_down = this.permissions['sys_news_down']
      this.newsManager_btn_source_create_delete = this.permissions['sys_news_source_create_delete']
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      formatNews(records) {
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (record.newsTags && record.newsTags.length > 0) {
              record.tagName = ''
              record.newsTags.forEach(function(newsTag, index) {
                if (index == 0) {
                  record.tagName += newsTag.newsTagName
                } else {
                  record.tagName += '，' + newsTag.newsTagName
                }
              })
            } else {
              record.tagName = '--'
            }

            if (record.sources && record.sources.length > 0) {
              record.sourceName = ''
              record.sources.forEach(function(source, index) {
                if (index == 0) {
                if (!source.isDisplay) {
                  record.sourceName += "<span style='color:#BBBBBB'>" + source.sourceName
                } else {
                  record.sourceName += "<span>" + source.sourceName
                }
              } else {
                if (!source.isDisplay) {
                  record.sourceName += "，<span style='color:#BBBBBB'>" + source.sourceName
                } else {
                  record.sourceName += "，<span>" + source.sourceName
                }
              }
              record.sourceName += "</span>"
              })
            } else {
              record.sourceName = '--'
            }

            if (record.isBanned == 0) { record.status = '已上架' }
            if (record.isBanned == 1) { record.status = '已下架' }
            if (!record.favoriteCount) { record.favoriteCount = 0 }
          })
        }
        return records
      },
      handleAddSourceClick() {
        // 资讯详情中的添加按键会调取此方法
        this.addSourceForm = {
          title: "",
          name: "",
          url: ""
        }
        this.dialogAddSourceVisible = true
        if (this.$refs['addSourceForm']) {
          this.$refs['addSourceForm'].resetFields();
        }
      },
      handleAddSource(formName) {
        // 添加来源中的保存按键会调取此方法
        let _this = this
        if (_this.addSourceing) { return false }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let newsSource = {
              articleTitle: _this.addSourceForm.title,
              sourceName: _this.addSourceForm.name,
              articleUrl: _this.addSourceForm.url,
              newsId: _this.newsDetail.id
            }
            _this.addSourceing = true
            addNewsSource(newsSource).then(response => {
              let code = response.status
              _this.addSourceing = false
              if (code == 200) {
                _this.dialogAddSourceVisible = false
                initDetail(_this)
                _this.$message({
                  showClose: true,
                  message: '添加来源成功',
                  type: 'success'
                })
              } else {
                _this.$message({
                  showClose: true,
                  message: '添加来源失败',
                  type: 'error'
                })
              }
            }).catch(function () {
              _this.addSourceing = false
              _this.$message({
                showClose: true,
                message: '添加来源失败',
                type: 'error'
              })
            })
          } else {
            return false;
          }
        });
      },
      handleDeleteSourceClick(row, index) {
        // 资讯详情-来源中的删除按键会调取此方法
        var _this = this
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return delNewsSources(row.articleId)
        }).then(data => {
          _this.hasDeletedSource = true
          _this.deleteNewsDetailSources(_this.newsDetail.sources, row)
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
        }).catch(function (err) {
        })
      },
      deleteNewsDetailSources(sources, rows) {
        // 从来源列表中移除选择的来源
        if (sources && sources.length > 0) {
          for(let i=0; i<sources.length; i++) {
            if (sources[i]['articleId'] == rows.articleId) {
              this.newsDetail.sources.splice(i, 1)
              break
            }
          }
        }
      },
      handleAddRelatedNewsClick() {
        // 资讯详情-相关资讯-添加按键会调取此方法
        this.dialogAddRelatedNewsVisible = true
        this.getAddRelatedNews()
      },
      handleDeleteRelatedNewsClick(row, index) {
        // 资讯详情-相关资讯-资讯行的删除按键会调取此方法
        var _this = this
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return delRelatedNews(_this.id, row.newsId);
        }).then(data => {
          _this.getRelatedNews()
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
        }).catch(function (err) {
        })
      },
      handleUpdate(row) {
        // 资讯详情-编辑按键会调取此方法
        let _this = this
        this.editForm = {
          id: row.id,
          title: row.title,
          summary: row.summary,
          tagIds: []
        }

        if (row.isBanned) { this.$set(this.editForm, 'isBanned', 1) }
        else { this.$set(this.editForm, 'isBanned', 0) }

        if (row.newsTags && row.newsTags.length > 0) {
          row.newsTags.forEach(function(newsTag, index) {
            _this.editForm.tagIds.push(newsTag.newsTagId)
          })
        }
        this.dialogEditVisible = true

        if (this.$refs['editForm']) {
          this.$refs['editForm'].resetFields();
        }
        // this.getCurrentTags('editTagOptions')
      },
      handleEditSave(formName) {
        // 编辑详情dialog-保存按键会调取此方法
        let _this = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let news = {
              id: _this.editForm.id,
              summary: _this.editForm.summary,
              isBanned: _this.editForm.isBanned,
              title: _this.editForm.title
            }
            news.newsTags = _this.getPublishNewsTags(_this.editForm.tagIds)
            putNews(news).then(response => {
              let code = response.status
              if (code == 200) {
                this.dialogEditVisible = false
                _this.$message({
                  showClose: true,
                  message: '编辑成功',
                  type: 'success'
                })
                _this.$route.query.edit = false
                initDetail(_this)
              } else {
                _this.$message({
                  showClose: true,
                  message: '编辑失败',
                  type: 'error'
                })
              }
            }).catch(function () {
              _this.$message({
                showClose: true,
                message: '编辑失败',
                type: 'error'
              })
            })
          }
        })
      },
      cancelEdit(formName) {
        // 编辑详情dialog-取消按键会调取此方法
        this.dialogEditVisible = false
        this.editForm = {
          id: null,
          title: "",
          summary: "",
          tagIds: [],
          isBanned: null
        }
      },
      remoteSearchTag (params) {
        let _this = this
        if (params && params.trim()) {
          getTagListByTag({
            tagName: params.trim(),
            tagTypeId: 4
          }).then(response => {
            if (response.status === 200) {
              let tags = response.data.data
              if (tags && tags.length > 0) {
                tags.forEach(function(tag, index) {
                  if (_this.editTagOptions.filter(x => x.value === tag.id).length === 0) {
                    _this.editTagOptions.push({
                      label: tag.name,
                      value: tag.id
                    })
                  }
                })
              }
            }
          }).catch(error => {
            console.error(error)
            this.$message({
              message: "获取标签失败",
              type: "error"
            })
          })
        }
      },
      getCurrentTags(property) {
        // 调取资讯所有标签
        let _this = this
        let tags = []
        let params = {
          type: 4  // 新闻标签类型
        }
        getTagList(params).then(response => {
          if (response.status == 200) {
            tags = response.data.data

            if (property == 'editTagOptions') {
              _this.editTagOptions = []
              if (tags && tags.length > 0) {
                tags.forEach(function(tag, index) {
                  _this.editTagOptions.push(
                  {
                    label: tag.name,
                    value: tag.id
                  })
                })
              }
            }
          }
        })
        return tags
      },
      getPublishNewsTags(tagIds) {
        let newsTags = []
        if (tagIds && tagIds.length > 0) {
          tagIds.forEach(function(tagId, index) {
            newsTags.push({
              newsTagId: tagId
            })
          })
        }
        return newsTags
      },
      getRelatedNews() {
        // 资讯详情-相关资讯-分页列表返回该资讯的相关资讯
        let params = {
          current: this.relatedNewsFilter.current,
          size: this.relatedNewsFilter.size
        }
        getRelatedNews(params, this.id).then(response => {
          this.relatedNewsData = this.formatNews(response.data.data.records)
          this.relatedNewsPage.total = response.data.data.total
        })
      },
      relatedNewsCurrentChange(val) {
        this.relatedNewsPage.currentPage = val
        this.relatedNewsFilter.current = val
        this.getRelatedNews();
      },
      relatedNewsSizeChange(val) {
        this.relatedNewsPage.pageSize = val
        this.relatedNewsPage.currentPage = 1
        this.relatedNewsFilter.size = val
        this.relatedNewsFilter.current = 1
        this.getRelatedNews();
      },
      getAddRelatedNews() {
        // 资讯详情-添加相关资讯-分页列表返回所有资讯
        let params = {
          newsId: this.id,
          current: this.addNewsFilter.current,
          size: this.addNewsFilter.size
        }
        // 添加筛选条件
        if (this.addNewsFilter.title != '' && this.addNewsFilter.title.trim() != '') {
          params.title = this.addNewsFilter.title.trim()
        }
        if (this.addNewsFilter.selectedTag != '' && this.addNewsFilter.selectedTagId != null
          && this.addNewsFilter.selectedTagId != '') {
          params.newsTagId = this.addNewsFilter.selectedTagId
        }
        getAddRelatedNewsPage(params).then(response => {
          this.addRelatedNewsData = this.formatNews(response.data.data.records)
          this.addRelatedNewsPage.total = response.data.data.total
        })
      },
      getTagsByTagProp(query, done) {
        // 资讯详情-添加相关资讯-标签搜索动态加载
        let _this = this
        let tags = []
        let params = {
          tagName: query,
          tagTypeId: 4
        }
        getTagListByTag(params).then(response => {
          if (response.status == 200) {
            tags = response.data.data
            _this.addNewsFilter.tags = []
            if (tags && tags.length > 0) {
              tags.forEach(function(tag, index) {
                _this.addNewsFilter.tags.push( {value: tag.name, id: tag.id} )
              })
            }
            done(_this.addNewsFilter.tags)
          }
        }).catch(err => {
        })
      },
      handleSelect(item) {
        this.addNewsFilter.selectedTagId = item.id
      },
      initAddRelatedNewsPage() {
        this.addRelatedNewsPage.currentPage = 1
        this.addRelatedNewsPage.pageSize = this.addNewsFilter.size
        this.addNewsFilter.current = 1
      },
      searchChangeAdd() {
        // 添加相关资讯-搜索
        this.initAddRelatedNewsPage()
        this.getAddRelatedNews()
      },
      searchResetAdd() {
        // 添加相关资讯-取消搜索
        this.addNewsFilter.title = ""
        this.addNewsFilter.selectedTag = null
        this.addNewsFilter.selectedTagId = undefined
        this.searchChangeAdd()
      },
      addRelatedNewsCurrentChange(val) {
        this.addRelatedNewsPage.currentPage = val
        this.addNewsFilter.current = val
        this.getAddRelatedNews();
      },
      addRelatedNewsSizeChange(val) {
        this.addRelatedNewsPage.pageSize = val
        this.addRelatedNewsPage.currentPage = 1
        this.addNewsFilter.size = val
        this.addNewsFilter.current = 1
        this.getAddRelatedNews();
      },
      changeSelectedRelatedNews(val) {
        // 添加相关资讯-多选框点击操作
        this.selectedRelatedNews = val;
      },
      saveSelectedRelatedNews() {
        // 添加相关资讯-保存按键会调取此方法
        let result = []
        let _this = this
        this.dialogAddRelatedNewsVisible = false
        this.selectedRelatedNews.forEach(function(record, index) {
          let elem = {
            newsId: Number(_this.id),
            relatedNewsId: record.newsId,
            isActive: 1,
            updatedBy: -1
          }
          result.push(elem)
        })
        addRelatedNews(result).then(response => {
          if (response.status == 200) {
            _this.$message({
              showClose: true,
              message: '添加相关资讯成功',
              type: 'success'
            })
            _this.getRelatedNews()
          } else {
            _this.$message({
              showClose: true,
              message: '添加相关资讯失败',
              type: 'error'
            })
          }
        }).catch(error => {
          _this.$message({
            message: '添加相关资讯失败',
            type: 'error'
          })
        })
      },

    }
  }

</script>

<style lang="scss" scoped>
.news-detail {
  .news-detail-item {
    font-size: 16px;
    margin: 10px 0;
  }
  .news-detail-title {
    margin-top: 40px;
    &-button {
      position: absolute;
      right: 2px;
      top: 5px;
      padding: 8px 12px;
    }
  }
  .news-detail-source {
    margin-top: 7px;
    max-height: 400px;
    overflow: auto;
  }
  .news-detail-source-title {
    margin-right: 5px;
    &-button {
      float: right;
      margin-top: -7px;
      padding: 8px 12px;
    }
  }
  .news-detail-dialog {
    &-publish-save {
      padding: 8px 12px;
      float: right;
    }
    &-publish-cancel {
      padding: 8px 12px;
      float: right;
      margin-right: 10px;
    }
    &-title {
      width: 600px;
    }
    &-item {
      width: 500px;
    }
    &-summary {
      width: 1075px;
    }
  }
  .news-detail-add-dialog {
    &-filter {
      &-label {
        float: left;
        padding-left: 16px;
        font-size: 14px;
        margin: -10px 0px -10px;
      }
      &-value {
        float: left;
        width: 140px;
        padding-left: 57px;
        margin: -15px 0px 0px;
      }
      &-search {
        float: right;
        margin-top: -15px;
        margin-right: 25px;
      }
      &-reset {
        float: right;
        margin-top: -15px;
        margin-right: 8px;
      }
    }
  }
  .news-detail-relatedNews {
    &-button {
      float: right;
      padding: 8px 12px;
    }
    &-save {
      float: right;
      padding: 8px 12px;
      margin: -8px -1px;
    }
  }
}
</style>
